import { xCoreHelper} from './core';

import { Map as Module_Map } from './map';

export var UI = {};

UI.init = function () {  
  UI.init_listners();
  
  if (xCoreHelper.f_page_is_in_mini_client_mode())
  	UI.set_mini_mode();

  window.UI_ = UI;
}

UI.set_mini_mode = function() {
	document.querySelector('body').classList.add('mini-mode');
    Module_Map.f_update_size();
}

UI.toggle_full_screen_mode = function() {
	document.querySelector('body').classList.toggle('imersive-mode');
    Module_Map.f_update_size();
}

UI.changeStyle = function (elementReference, elementSelector, cssProperty, cssPropertyNewValue) {
  var domElement = null;
  switch (elementSelector) {
    case "id":
      domElement = document.querySelector("#" + elementReference);
      break;
    case "class":
      domElement = document.querySelector("." + elementReference);
      break;
  }

  if (domElement && cssProperty && cssPropertyNewValue) 
  {
    domElement.style.setProperty(cssProperty, cssPropertyNewValue);
  }
};

UI.init_listners = function ()
{
};
